import React, { useEffect, useState } from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { Box } from "@mui/material";
import theme from "./theme";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import UvodSection from "./sections/UvodSection";
import CenikSection from "./sections/CenikSection";
import SluzbySection from "./sections/SluzbySection";
import GalerieSection from "./sections/GalerieSection";
import KontaktSection from "./sections/KontaktSection";
import { Config } from "./model/Config";

function App() {
  const [config, setConfig] = useState<Config>();

  useEffect(() => {
    fetch("/config.json")
      .then((r) => r.json())
      .then((json) => setConfig(json))
      .catch((err) => console.error("Error fetching config:", err));
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Navbar />
        <HeroSection />
        {config ? (
          <>
            <UvodSection saleDates={config.saleDates} />
            <CenikSection steaks={config.prices.steaks} entrails={config.prices.entrails} />
          </>
        ) : null}
        <SluzbySection />
        <GalerieSection />
        <KontaktSection />
      </Box>
    </ThemeProvider>
  );
}

export default App;
